import AuthUtil from '../redux/AuthUtil';
import { ALERTS, SPACE } from '../components/global/Server/endpoints';

// Thin wrapper over the alert/notification endpoints, in the Hive house style
// (see spaceApi.js / accessApi.js). listAlerts returns the alerts the current
// user is allowed to see (server scopes them by companyId + recipientUserId).
// resolve deletes an alert; accept/decline handle SPACE_INVITE notifications
// inline (the server clears the invite alert on either action).
const alertsApi = {
  list: () => AuthUtil.getRequest(ALERTS.FETCH_ALERTS),
  resolve: (alertId) => AuthUtil.postRequest(ALERTS.RESOLVE_ALERT, { alertId }),
  acceptInvite: (spaceId) => AuthUtil.postRequest(SPACE.ACCEPT_INVITE, { spaceId }),
  declineInvite: (spaceId) => AuthUtil.postRequest(SPACE.DECLINE_INVITE, { spaceId }),
};

// Cross-component signal: the Updates feed and the top-bar bell badge fetch the
// alert list independently. When one mutates it (dismiss / clear all / answer an
// invite), it fires this event so the other refreshes immediately instead of
// waiting for its next poll — so the badge count drops the moment you dismiss.
export const ALERTS_CHANGED_EVENT = 'beenexa:alerts-changed';
export function notifyAlertsChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(ALERTS_CHANGED_EVENT));
  }
}

export default alertsApi;
